<script>
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required, requiredIf } from '@vuelidate/validators';
import router from '../../../../index';
import { isNumber } from 'shared/helpers/Validators';
import { loadScript } from 'dashboard/helper/DOMHelpers';
import * as Sentry from '@sentry/browser';

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      inboxName: '',
      phoneNumberId: '',
      WABAId: '',
      responseCode: '',
      hasCoexistance: false,
      isLoading: false,
    };
  },
  validations: {
    inboxName: { required },
    WABAId: { required },
    responseCode: { required },
  },
  mounted() {
    window.fbAsyncInit = this.runFBInit;
    window.addEventListener('message', this.handleWhatsappEvents);
  },
  beforeUnmount() {
    window.removeEventListener('message', this.handleWhatsappEvents);
  },
  methods: {
    handleWhatsappEvents(event) {
      if (
        event.origin !== 'https://www.facebook.com' &&
        event.origin !== 'https://web.facebook.com'
      )
        return;
      try {
        const data = JSON.parse(event.data);
        if (data.type === 'WA_EMBEDDED_SIGNUP') {
          if (data.event === 'FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING')
            this.hasCoexistance = true;
          if (data.data.phone_number_id)
            this.phoneNumberId = data.data.phone_number_id;
          this.WABAId = data.data.waba_id;
        }
      } catch (err) {}
    },
    async startLogin() {
      this.isLoading = true;
      try {
        await this.loadFBsdk();
        this.runFBInit();
        this.tryFBlogin();
      } catch (error) {
        if (error.name === 'ScriptLoaderError') {
          useAlert(this.$t('INBOX_MGMT.DETAILS.ERROR_FB_LOADING'));
        } else {
          Sentry.captureException(error);
          useAlert(this.$t('INBOX_MGMT.DETAILS.ERROR_FB_AUTH'));
        }
      }
    },
    async loadFBsdk() {
      return loadScript('https://connect.facebook.net/en_US/sdk.js', {
        id: 'facebook-jssdk',
      });
    },
    runFBInit() {
      FB.init({
        appId: window.chatwootConfig.fbAppId,
        xfbml: true,
        version: 'v22.0',
        autoLogAppEvents: true,
      });
      window.fbSDKLoaded = true;
      FB.AppEvents.logPageView();
    },
    tryFBlogin() {
      FB.login(
        response => {
          if (response.authResponse) {
            this.responseCode = response.authResponse.code;

            setTimeout(() => {
              this.createChannel();
            }, 1000);
          } else {
            this.isLoading = false;
          }
        },
        {
          config_id: window.chatwootConfig.waEsConfigId,
          response_type: 'code',
          override_default_response_type: true,
          extras: {
            setup: {},
            featureType: 'whatsapp_business_app_onboarding',
            sessionInfoVersion: '3',
          },
        }
      );
    },
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        this.isLoading = false;
        return;
      }

      try {
        const whatsappChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: this.inboxName,
            channel: {
              type: 'whatsapp',
              provider: 'whatsapp_cloud_new',
              provider_config: {
                code: this.responseCode,
                phone_number_id: this.phoneNumberId,
                waba_id: this.WABAId,
                business_app_onboarding: this.hasCoexistance,
              },
            },
          }
        );

        this.isLoading = false;

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: whatsappChannel.id,
          },
        });
      } catch (error) {
        this.isLoading = false;
        useAlert(
          error.message || this.$t('INBOX_MGMT.ADD.WHATSAPP.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<template>
  <form class="flex flex-wrap mx-0" @submit.prevent="startLogin()">
    <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
      <label :class="{ error: v$.inboxName.$error }">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.LABEL') }}
        <input
          v-model.trim="inboxName"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.PLACEHOLDER')"
          @blur="v$.inboxName.$touch"
        />
        <span v-if="v$.inboxName.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.ERROR') }}
        </span>
      </label>
    </div>
    <div class="w-full">
      <woot-button :isLoading="isLoading" :disabled="!inboxName">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.EMBEDDED') }}
        <img
          src="~dashboard/assets/images/channels/whatsapp_icon.png"
          alt="Login with Whatsapp"
          class="w-auto h-6"
        />
      </woot-button>
    </div>
  </form>
</template>
